import { useTheme } from '@mui/material';

export const IntroIcon3 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                d="M13 10.0179C10.2375 10.0179 8 12.2554 8 15.0179V33.0179C8 35.7804 10.2375 38.0179 13 38.0179H35C37.7625 38.0179 40 35.7804 40 33.0179V19.0179C40 16.2554 37.7625 14.0179 35 14.0179H15C14.45 14.0179 14 14.4679 14 15.0179C14 15.5679 14.45 16.0179 15 16.0179H35C36.6562 16.0179 38 17.3617 38 19.0179V33.0179C38 34.6742 36.6562 36.0179 35 36.0179H13C11.3438 36.0179 10 34.6742 10 33.0179V15.0179C10 13.3617 11.3438 12.0179 13 12.0179H37C37.55 12.0179 38 11.5679 38 11.0179C38 10.4679 37.55 10.0179 37 10.0179H13ZM32 27.5179C32.3978 27.5179 32.7794 27.3599 33.0607 27.0786C33.342 26.7973 33.5 26.4158 33.5 26.0179C33.5 25.6201 33.342 25.2386 33.0607 24.9573C32.7794 24.676 32.3978 24.5179 32 24.5179C31.6022 24.5179 31.2206 24.676 30.9393 24.9573C30.658 25.2386 30.5 25.6201 30.5 26.0179C30.5 26.4158 30.658 26.7973 30.9393 27.0786C31.2206 27.3599 31.6022 27.5179 32 27.5179Z"
                fill={primaryIconStrokeColor}
            />
        </svg>
    );
};
